import React, {useContext} from 'react';
import {useSelector} from 'react-redux';
import Box from '@material-ui/core/Box';
import {makeStyles} from '@material-ui/core/styles';
import {useLocation} from 'react-router';

import AppContext from '../../utility/AppContext';
import Layouts from './Layouts';
import {ContentView} from '../../index';
import useStyles from '../../../shared/jss/common/common.style';
import {AppState} from '../../../redux/store';
import AppContextPropsType from '../../../types/AppContextPropsType';

const useStyle = makeStyles(() => ({
  appAuth: {
    flex: 1,
    display: 'flex',
    position: 'relative',
    height: '100vh',
    backgroundColor: '#f3f4f6',
    background: `url(/assets/images/auth-background.jpg) no-repeat center center`,
    backgroundSize: 'cover',

    '& .scrollbar-container': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    '& .main-content-view': {
      padding: 20,
    },
    '& .footer': {
      marginRight: 0,
      marginLeft: 0,
    },
  },
  appSpecialPage: {
    flex: 1,
    display: 'flex',
    position: 'relative',
    height: '100vh',
    backgroundColor: '#313541',
    backgroundSize: 'cover',

    '& .scrollbar-container': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    '& .main-content-view': {
      padding: 20,
    },
    '& .footer': {
      marginRight: 0,
      marginLeft: 0,
    },
  },
  appHomePage: {
    '& .ps': {
      overflow: 'unset !important',
    },
  },
}));

interface CremaLayoutProps {}

const CremaLayout: React.FC<CremaLayoutProps> = () => {
  useStyles();
  const location = useLocation();
  const {navStyle} = useContext<AppContextPropsType>(AppContext);
  const {user} = useSelector<AppState, AppState['auth']>(({auth}) => auth);
  const AppLayout = Layouts[navStyle];
  const classes = useStyle();
  const path = location.pathname.split('/');

  const isChatPage = path[1] === 'chat';
  const isTrackTourPage = path[1] === 'track';
  const publicTourPage = location.pathname === '/public/track';

  const isHomePage = location.pathname === '/';
  const isSpecialPage = isChatPage;

  return (
    <>
      {user && !isChatPage && !isTrackTourPage && !publicTourPage ? (
        <AppLayout />
      ) : (
        <Box
          className={
            isHomePage
              ? classes.appHomePage
              : isSpecialPage
              ? classes.appSpecialPage
              : classes.appAuth
          }>
          <ContentView />
        </Box>
      )}
    </>
  );
};

export default React.memo(CremaLayout);
